module.exports = window["__sharedReact"];